
<template>

  <div class="ui segments">

    <div class="ui center aligned segment">
      <span class="ui almarai text" :class="[!work.concluded ? 'primary' : 'secondary']">
        المشاركات: {{ work.completed }}
        <span v-if="isTarget">من {{ work.target }}</span>
      </span>
    </div>

    <div class="ui center aligned segment" v-if="counter">
      <i class="primary stopwatch icon" />
      &nbsp;
      <span class="ui almarai primary text">{{ counter }}</span>
    </div>

  </div>

</template>

<script>
import countdown from 'countdown';
countdown.setLabels(
  ' م. ث.| ثانية| دقيقة| ساعة| يوم| أسبوع| شهر| سنة| عقد| قرن| ألفية',
  ' م. ث.| ثانية| دقيقة| ساعة| يوم| أسابيع| شهور| سنوات| عقود| قرون| ألفية',
  ' , ',
  ' , ',
  '');

export default {

  name: 'Counter',
  props: {

    work: Object,
    currentTime: Date

  },
  computed: {

    isTarget() {

      return this.work.target && !this.work.concluded

    },

    counter() {

      if (this.work.target || this.work.concluded)
        return null;

      return countdown(

        this.currentTime,
        new Date(this.work.deadline),
        countdown.DEFAULTS,
        2

      );

    }

  }

}
</script>
